import React from 'react'
import { Element } from 'react-scroll'
// @ts-ignore
import Fade from 'react-reveal/Fade'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { TwoTitle } from '../atoms/two_title'
import { Image } from '../atoms/image'

interface IValuePropositionItem {
  personImage: string,
  title: string,
  details: {
    title: string,
    description: string
  }[]
}

export const ValuePropositionView = () => {

  const cards: IValuePropositionItem[] = [
    {
      personImage: 'human1.jpg',
      title: '患者様への提供価値',
      details: [
        { title: "アジア人に特化した治療を提供", description: "歯槽骨が薄く、歯根が短い等といったアジア人特有の特徴に最適化された治療を受けることが出来ます。" },
        { title: "LINEで気軽に相談", description: "hanaloveの公式LINEに登録することで、矯正に関するお困りごとを気軽にご相談いただける環境を提供しています。" },
        { title: "3つのプランから選択可能", description: "あらゆる症例に対応でき、患者様の口腔内の状態に応じてEasy、Smart、Premiumの3つのプランを選ぶことが可能です。" },
      ],
    },
    {
      personImage: 'human2.jpg',
      title: '歯科医師への提供価値',
      details: [
        { title: "全てのスキャナー、石膏模型で対応が可能", description: "iTero、TORIOS、Primescan、等の全ての口腔内スキャナーや石膏模型で受付が可能です。※STLまたは、PLYのデータ・フォーマットで外部出力ができる機器が対象です。" },
        { title: "CT連携し、専門医が治療計画作成を支援", description: "CTデータと連携することで、歯牙のみならず歯根と歯槽骨の関係性も治療計画上から確認が行えるようになり、歯肉退縮のリスク管理や、歯牙の動揺を把握することが可能です。" },
        { title: "導入費用が無料", description: "セミナーへの参加、口腔内スキャナーの購入は必須ではないため、初期費用は一切必要ございません。" },
      ],
    },
  ]

  const renderMethod = () => cards.map((card, cardIndex) => (
    <section key={cardIndex} className="valuePropositionView--item">
      <div className="valuePropositionView--item--imageArea">
        <Image imageName={card.personImage} className="valuePropositionView--item--imageArea__image" />
      </div>
      <div className="valuePropositionView--item--detailArea">
        <h4 className="valuePropositionView--item--detailArea__title">{card.title}</h4>
        {card.details.map((detail, detailIndex) => (
          <div key={detailIndex} className="valuePropositionView--item--detailArea--item">
            <p className="valuePropositionView--item--detailArea--item--titleArea">
              <div className="valuePropositionView--item--detailArea--item--titleArea--checkArea">
                <i className="fas fa-check"></i>
              </div>
              <h5 className="valuePropositionView--item--detailArea--item--titleArea__title">{detail.title}</h5>
            </p>
            <p className="valuePropositionView--item--detailArea--item__description">{detail.description}</p>
          </div>
        ))}
      </div>
    </section>
  ))

  return (
    <Fade left cascade duration={500} distance="40px">
      <section className="content">
        <Element name="page-value" className="valuePropositionView">
          <TwoTitle jpnLabel='提供価値' engLabel='Value proposition' />
          <section className="valuePropositionView--listArea valuePropositionView--listArea__pc">
            {renderMethod()}
          </section>
          <Carousel
            showArrows={false}
            showStatus={false}
            showThumbs={false}
            centerMode={true}
            emulateTouch={true}
            centerSlidePercentage={91}
            preventMovementUntilSwipeScrollTolerance={true}
            swipeScrollTolerance={100}
            className="valuePropositionView--listArea valuePropositionView--listArea__sp"
          >
            {renderMethod()}
          </Carousel>
        </Element>
      </section>
    </Fade>
  )
}